import { render, staticRenderFns } from "./activesSign.vue?vue&type=template&id=1c2cc314&scoped=true&"
import script from "./activesSign.vue?vue&type=script&lang=js&"
export * from "./activesSign.vue?vue&type=script&lang=js&"
import style0 from "./activesSign.vue?vue&type=style&index=0&id=1c2cc314&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2cc314",
  null
  
)

export default component.exports